import { library } from '@fortawesome/fontawesome-svg-core'
import {
   faUsers,
   faSignOutAlt,
   faUserPlus,
   faUserEdit,
   faMinusCircle,
   faTimesCircle,
} from '@fortawesome/free-solid-svg-icons'
import { faCalendarAlt } from '@fortawesome/free-regular-svg-icons'

library.add(
   faCalendarAlt,
   faUsers,
   faSignOutAlt,
   faUserPlus,
   faUserEdit,
   faMinusCircle,
   faTimesCircle
)
